import { useNavigate, useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import useAxiosPrivate from "middlewares/hooks/useAxiosPrivate";
import AddVendor from "./components/addvendor";
import Table from "pages/components/common_table";

const Vendors = () => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
      const [isLoading, setIsLoading] = useState(true);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const controller = new AbortController();
  const getVendors = async () => {
    try {
      const response = await axiosPrivate.get("/accounting/vendors/account", {
        signal: controller.signal,
      });
      setData(response.data.data.vendors);
      setIsLoading(false);
    } catch (error) {
      // console.log(error)
      if (error?.response?.status === 401) {
        navigate("/", {
          state: { from: location },
          replace: true,
        });
      }
    }
  };
  useEffect(() => {
    getVendors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
const refetch = () => {
  setIsLoading(true);
  getVendors();
}
  const columns = useMemo(
    () => [
      {
        id: "firstname", //access nested data with dot notation
        enableClickToCopy: true,
        size: 50,
        header: "Firstname",
        accessorFn: (row) => row?.firstname,
      },
      {
        id: "lastname", //access nested data with dot notation
        enableClickToCopy: true,
        size: 50,
        header: "Lastname",
        accessorFn: (row) => row?.lastname,
      },
      {
        id: "contact", //access nested data with dot notation
        enableClickToCopy: true,
        size: 50,
        header: "Contact / Email",
        accessorFn: (row) => `${row?.contact} - ${row?.email}`,
      },
      {
        id: "company", //access nested data with dot notation
        enableClickToCopy: true,
        size: 50,
        header: "Company / Address",
        accessorFn: (row) => `${row?.company} - ${row?.address}`,
      },
    ],
    []
  );
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    setRoles(JSON.parse(localStorage.roles));
  }, []);
  return (
    <>
      <section className="py-2 mt-3">
        <div className="row">
          <div className="col-lg-12">
            <div className="card mb-5 mb-lg-0">
              <AddVendor
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                getVendors={getVendors}
              />
              <div className="card-body p-0">
                <Table
                  columns={columns}
                  data={data}
                  isLoading={isLoading}
                  refetch={refetch}
                  headers={
                    <div className="row">
                      <div className="col-md-6">
                        <h2 className="h6 mb-0 text-uppercase text-center">
                          Vendors
                        </h2>
                      </div>
                      <div className="col-md-6">
                        {roles?.includes(1000030) && (
                          <button
                            className="btn btn-outline-dark text-small btn-sm rounded-0"
                            onClick={handleShowModal}
                          >
                            New Vendor
                          </button>
                        )}
                      </div>
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Vendors;
